"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Story_1 = require("./Story");
class StoryPointInfo {
    constructor(_storyPointInfoImpl, _workbookImpl) {
        this._storyPointInfoImpl = _storyPointInfoImpl;
        this._workbookImpl = _workbookImpl;
    }
    get index() {
        return this._storyPointInfoImpl.index;
    }
    get caption() {
        return this._storyPointInfoImpl.caption;
    }
    get active() {
        return this._storyPointInfoImpl.active;
    }
    get updated() {
        return this._storyPointInfoImpl.updated;
    }
    get parentStory() {
        return new Story_1.Story(this._storyPointInfoImpl.parentStory, this._workbookImpl);
    }
}
exports.StoryPointInfo = StoryPointInfo;
//# sourceMappingURL=StoryPointInfo.js.map